import angular from 'angular';
const MESSAGE_DISPLAY_DELAY_TIME = 15000;
export class DowngradeCallStateService {
    constructor(VideoProviderFactory, pn, $rootScope, $translate) {
        this.VideoProviderFactory = VideoProviderFactory;
        this.pn = pn;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.currentState = 'initial';
        this.currentPersonIsCulprit = false;
    }
    resetState(notify = true) {
        this.setState('initial', notify);
        this.currentPersonIsCulprit = false;
    }
    downgradeToAudioOnly({ currentPersonIsCulprit }) {
        if (this.wasDowngraded())
            return;
        this.currentPersonIsCulprit = currentPersonIsCulprit;
        this.setState('audio_only', true);
        this.VideoProviderFactory.activeProvider.togglePublishersVideo(false);
    }
    continueWithAudioOnly() {
        this.setState('continue_with_audio_only', true);
    }
    connectionImproved() {
        this.setState('improved');
        setTimeout(() => {
            if (this.isImproved()) {
                this.setState('improved_without_message');
            }
        }, MESSAGE_DISPLAY_DELAY_TIME);
    }
    turnOnVideo() {
        if (this.wasDowngraded()) {
            this.setState('continue_with_video', true);
        }
    }
    wasDowngraded() {
        return this.currentState !== 'initial';
    }
    wasNotifiedAboutImprove() {
        return [
            'improved',
            'improved_without_message',
            'continue_with_audio_only',
            'continue_with_video',
        ].includes(this.currentState);
    }
    isShownDowngradeFrame() {
        return ['audio_only', 'improved', 'continue_with_audio_only'].includes(this.currentState);
    }
    isAudioOnly() {
        return this.currentState === 'audio_only';
    }
    get downgradeReasonText() {
        return `video-chat.downgrade-to-audio-only.top-reason-disabled`;
        // TODO: waiting for Andrey A
        // if (this.currentPersonIsCulprit) {
        //   return 'video-chat.downgrade-to-audio-only.top-reason-culprit-you';
        // } else {
        //   const amIDoctor = !!this.pn.globalState.userId;
        //   if (amIDoctor) {
        //     return 'video-chat.downgrade-to-audio-only.top-reason-culprit-patient';
        //   } else {
        //     return 'video-chat.downgrade-to-audio-only.top-reason-culprit-provider';
        //   }
        // }
    }
    isImproved() {
        return this.currentState === 'improved';
    }
    setState(state, notify = false) {
        this.currentState = state;
        if (notify) {
            this.$rootScope.$emit('activeProvider:downgradeToAudioOnly', { state });
        }
    }
}
export default angular
    .module('doxy.providers.video.common.services.downgradeCallStateService', [])
    .service('downgradeCallStateService', DowngradeCallStateService).name;
